import { atom } from 'jotai'
/**广场详情页图片轮播index */
export const detailSwiperIndexAtom = atom<number>(0)
